exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.profile-account-change-password[data-v-352f2a14]{height:100%}div.content[data-v-352f2a14]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}", ""]);

// exports
